export interface DashboardProps<T> {
  data: T | null;
  expanded?: boolean;
  showError: boolean;
  loading: boolean;
  isEmpty?: boolean;
}
